import React, { useState, useEffect } from 'react';
import { useAuth, UserPropertyName } from 'contexts/AuthProvider';
import AvatarIcon from './AvatarIcon';
import { FormattedMessage } from 'react-intl';
import { useSiteConfig } from 'contexts/SiteConfigProvider';

function LoginBar() {
  const { authenticating, isAuthenticated, getUserProperty, logIn, logOut } = useAuth();
  const { getRegistrationLink } = useSiteConfig();
  const handleRegistrationClick = () => window.location.replace(getRegistrationLink());
  const handleLogoutClick = () => logOut();
  const avatarIcon = <AvatarIcon width={22} height={22}></AvatarIcon>;

  return (
    !authenticating && isAuthenticated() ?
      <>
        <span className="me-2">{avatarIcon}</span>
        <span className="me-4">{getUserProperty(UserPropertyName.DISPLAY_NAME)}</span>
        <span><a href={void (0)} style={{ cursor: 'pointer' }} onClick={handleLogoutClick}><FormattedMessage id="ml_114717" defaultMessage="X - Log Out"/></a></span>
      </> :
      <a href={void (0)} style={{ cursor: 'pointer' }} onClick={handleRegistrationClick}>{avatarIcon}</a>
  );
}

export default LoginBar;